import CardPanel from './card-panel';
export default CardPanel;
